module.exports = __webpack_public_path__ + "static/img/HanYuan_Banner_autumn.cfda0e83.jpg";